<script>
/**
 * @overview 应用组件头部
 *
 * @author huojinzhao
 */

import { mapState } from "vuex";
import { $http, $token } from "@/utils";

export default {
  name: "TheHeader",

  computed: {
    ...mapState(["user"]),

    routes() {
      return this.$route.matched
        .reduce((acc, route, index, arr) => {
          const { meta: { label }, path } = route;

          const item = index === arr.length - 1
            ? { label }
            : { label, to: path };

          return [...acc, item];
        }, []);
    },
  },

  methods: {
    goBack() {
      this.$router.back();
    },

    goHome() {
      this.$router.push("/");
    },

    logoutConfirm() {
      this.$alert(
        "是否确定退出登录？",
        {
          showCancelButton: true,
          type: "warning",
        },
      )
        .then(this.logout);
    },

    logout() {
      $http.post("/user/logout", {})
        .then(() => {
          $token.remove();

          window.location.href = "/login";
        });
    },
  },
};
</script>

<template>
  <div
    v-show="$store.state.course.isShowHead"
    class="the-header">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(route,index) in routes"
        :key="route.label"
        v-bind="route"
      >
        <span
          :class="{'home':index === 0}"
          @click="index === 0?goHome():null">{{ route.label }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <span class="the-header__user">
      <i class="iconfont icon-user" />
      {{ user.realname }}
    </span>
    <i
      class="iconfont icon-left-circle"
      title="上一步"
      @click="goBack"
    />
    <i
      class="iconfont icon-home"
      title="返回首页"
      @click="goHome"
    />
    <i
      class="iconfont icon-export"
      title="退出登录"
      @click="logoutConfirm"
    />
  </div>
</template>

<style lang="postcss">
.the-header {
  --font-size: 20px;
}

.the-header {
  display: flex;
  align-items: center;
  padding: 0 2em;
  height: 60px;
  box-shadow: 0 0 3px 3px var(--color-shadow);
  z-index: 0;
}

.the-header i {
  margin-left: 1em;
  font-size: var(--font-size);
}

.the-header .home {
  color: #303133;
  font-weight: 700;
  cursor: pointer;
  transition: color .2s cubic-bezier(.645,.045,.355,1);
}
.the-header .home:hover{
  color: #409EFF;
}

.the-header > i:hover {
  color: var(--color-primary);
  cursor: pointer;
}

.the-header .el-breadcrumb__inner {
  font-size: var(--font-size);
}

.the-header__user {
  margin-left: auto;
  font-size: var(--font-size);
}
</style>
